var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.liveList.vid ? _c('div', {
    staticClass: "live-video"
  }, [_c('a', {
    staticClass: "live-video-link",
    attrs: {
      "target": _vm.target
    },
    on: {
      "click": function click($event) {
        return _vm.getLiveRoomLink(_vm.liveList.vid);
      }
    }
  }, [_vm._m(0), _vm._v(" "), _vm.liveList.status == '0' ? _c('span', {
    staticClass: "live_watch"
  }, [_c('i', {
    staticClass: "f"
  }), _c('i', {
    staticClass: "s"
  }), _c('i', {
    staticClass: "t"
  }), _vm._v(_vm._s(_vm.$t("REPLAY")))]) : _c('span', {
    staticClass: "live_watch"
  }, [_c('i', {
    staticClass: "f"
  }), _c('i', {
    staticClass: "s"
  }), _c('i', {
    staticClass: "t"
  }), _vm._v(_vm._s(_vm.$t("LIVE")))]), _vm._v(" "), _c('p', {
    staticClass: "live-video-tag"
  }, [_vm._v(_vm._s(_vm.liveList.title))]), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.liveList.cover,
      "width": "100%"
    }
  })])]) : _vm._e();
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "mask"
  }, [_c('div', {
    staticClass: "play_bg"
  })]);
}];
export { render, staticRenderFns };